document.addEventListener('DOMContentLoaded', function() {
  var nofollowLinks = document.querySelectorAll('a[rel="nofollow"]');
  nofollowLinks.forEach(function(link) {
    link.setAttribute('aria-label', 'You are about the leave the USFA website and visit: ' + link.getAttribute('href'));
  });
});
